export default __webpack_public_path__ + "static/media/StepsInactive03.c5f1d2f0.svg";